import styled from 'styled-components';

import { mediaQuery } from '../../../styles/global';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
  gap: 1.5rem;
  width: 90%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 28.25rem;
  width: 100%;
  position: relative;
  box-sizing: border-box;

  ${mediaQuery.maxWidth.tablet} {
    min-height: fit-content;
    height: fit-content;
  }
`;

export const Text = styled.h3`
  color: #fff;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 3rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -1.92px;
  margin: 0;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
    letter-spacing: -1px;
  }
`;

export const TextURL = styled.p`
  color: rgba(255, 255, 255, 0.75);
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
  margin: 0;
`;

export const Img = styled.div<{ src: string }>`
  background-image: url(${({ src }) => src});
  border-radius: 1rem;
  width: 100%;
  background-size: cover;
  background-position: center;
  flex-grow: 1;
`;

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;

  ${mediaQuery.maxWidth.tablet} {
    background: linear-gradient(to right, #000, #000, transparent);
    border-radius: 1rem;
    padding: 2rem;
  }
`;

export const RightContainer = styled.div`
  flex: 1;
  display: flex;
  position: relative;

  ${mediaQuery.maxWidth.tablet} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export const ButtonText = styled.span`
  color: #0d0c11;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  z-index: 2;
`;

export const ArrowIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  filter: invert(1);
  transition: transform 0.3s ease-in-out;
  z-index: 2;
`;

export const Button = styled.a`
  width: fit-content;
  display: flex;
  height: 3.25rem;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 800px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: #fff;
  padding: 16px 32px;
  text-decoration: none;
  transition: all 0.3s ease-in-out;
  position: relative;
  will-change: transform;

  &:hover ${ArrowIcon} {
    transform: translateX(4px);
  }

  &:hover {
    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.75);
  }
`;
